import { CardHeader } from "reactstrap";
import { H6 } from "../../../../../../AbstractElements";
import { Filters } from "../../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { setSideBarOn } from "../../../../../../ReduxToolkit/Reducers/ECommerce/FilterSlice";

export const FilterHeader = () => {
  const dispatch = useAppDispatch();

  return (
    <CardHeader onClick={() => dispatch(setSideBarOn())}>
      <H6 className="mb-0 f-w-600">
        {Filters}
        <span className="pull-right">
          <i className="fa fa-chevron-down toggle-data"></i>
        </span>
      </H6>
    </CardHeader>
  );
};
